<div class="relative w-full min-w-[130px] max-w-full select-container" #selectContainer>
  <div
    class="flex items-center w-full h-[{{ dropdownHeight }}] border border-soft-gray  bg-white cursor-pointer px-0 py-0 max-w-full"
    (click)="toggleDropdown()" [style.border-radius]="radiusSearch">
    @if (isOpen()) {
    <i
      class="fi fi-rr-search pl-4 text-text-secondary leading-none text-base flex items-center justify-center min-w-[24px]"></i>
    <input [placeholder]="placeholder" type="text" [value]="isOpen() ? searchTerm : (selectedOption?.label || '')"
      (input)="isOpen() && onUserInput($event)" [readonly]="!isOpen()"
      class="flex-1 outline-none text-[{{ fontSize }}] font-poppins font-medium text-text-primary placeholder-text-primary bg-white focus:outline-none placeholder:text-text-placeholder placeholder:font-normal truncate whitespace-nowrap overflow-hidden min-w-0 max-w-full"
      [style.font-size]="fontSize" [style.font-weight]="fontWeight" [class.pl-2]="isOpen()"
      (click)="$event.stopPropagation()" />
    }
    @else {
    @if(selectedOption?.label) {
    <div
      class="flex-1 outline-none text-sm font-poppins font-medium bg-white truncate whitespace-nowrap overflow-hidden pl-4 min-w-0 max-w-full leading-[18px] text-text-primary"
      [style.font-size]="fontSize"
      [style.font-weight]="fontWeight">
      @if(getDisplayParentGroupLabel()) {
      <div class="flex gap-4 items-center">
        <p class="truncate" appTruncateTooltip>
          {{getDisplayParentGroupLabel()}}
        </p>
        <p class="bg-blue-bubble flex px-3 py-1 rounded-[13px] truncate" appTruncateTooltip> {{ selectedOption?.label }}</p>
      </div>
      }@else{
      <span appTruncateTooltip>{{ selectedOption?.label }}</span>
      }
    </div>
    }
    @else {
    <div
      class="flex-1 outline-none text-sm font-poppins font-medium bg-white truncate whitespace-nowrap overflow-hidden pl-4 min-w-0 max-w-full leading-[18px] text-text-placeholder"
      [style.font-size]="placeholderFontSize"
      [style.font-weight]="placeholderFontWeight">
      {{ placeholder }}
    </div>
    }
    }

    <i class="fi fi-rs-angle-small-down text-text-primary text-2xl ml-2 transform transition-transform duration-200 flex items-center justify-center mr-4"
      [class.rotate-180]="isOpen()"></i>
  </div>

  <!-- panel: lo movemos al body cuando se abre -->
  @if (isOpen()) {
  <div #panel class="absolute z-50 mt-1 w-full max-h-[304px] bg-white rounded-2xl animate-fadeIn flex flex-col"
    [style.box-shadow]="'0px 8px 16px 0px #00000029'">
    <ul class="overflow-auto flex-1 px-2 pb-2 mt-2">
      @for (option of filteredOptions; track option.value) {
      @if (option.options && option.options.length > 0) {
      <!-- Grupo -->
      <li class="px-4 py-2">
        <p class="text-text-secondary font-poppins font-semibold text-xs uppercase">
          {{ option.label }}
        </p>
        <ul class="mt-1">
          @for (subOption of option.options; track subOption.value) {
          <li
            class="px-4 py-2 hover:bg-primary-g50 hover:border-l-[3px] hover:border-primary-g300 hover:font-medium cursor-pointer rounded-lg"
            (click)="selectOption(subOption)">
            <p class="text-text-primary font-poppins text-sm hover:font-medium w-full truncate"
               [class.font-semibold]="subOption.isStrong"
               [class.font-normal]="!subOption.isStrong"
               appTruncateTooltip>
              {{ subOption.label }}
            </p>
          </li>
          }
        </ul>
      </li>
      } @else {
      <!-- Opción simple -->
      <li
        class="px-4 py-2 hover:bg-primary-g50 hover:border-l-[3px] hover:border-primary-g300 hover:font-medium cursor-pointer rounded-lg"
        (click)="selectOption(option)">
        <p class="text-text-primary font-poppins text-sm hover:font-medium w-full truncate"
           [class.font-semibold]="option.isStrong"
           [class.font-normal]="!option.isStrong"
           appTruncateTooltip>
          {{ option.label }}
        </p>
      </li>
      }
      }
      @if (filteredOptions.length === 0) {
      <li class="px-4 py-2 text-sm text-text-primary font-poppins font-normal">
        No hay resultados
      </li>
      }
    </ul>
  </div>
  }
</div>